import { signDocumentsFilters } from '@/config';
import tableHelper from '@/services/tableHelper';
import http from '../services/http';

const signDocuments = {
  documentsIndex(tableFilters, filterStatus, config = {}) {
    const where = tableHelper.whereFilters(filterStatus, signDocumentsFilters);
    return http.request({
      method: 'get',
      url: '/signature-requests',
      params: { filter: { ...tableFilters, where } },
      ...config,
    });
  },
  documentsCount(filterStatus, config = {}) {
    const where = tableHelper.whereFilters(filterStatus, signDocumentsFilters);
    return http.request({
      method: 'get',
      url: '/signature-requests/count',
      params: { where },
      ...config,
    });
  },
  signDocuments(signatureRequestIds, otp) {
    return http.request({
      method: 'post',
      url: '/signature-requests/sign',
      data: {
        signatureRequestIds,
        otp,
      },
    });
  },
  getSignedPdf(id) {
    return http.request({
      method: 'get',
      url: `/signature-requests/${id}/signed-pdf`,
      responseType: 'blob',
    });
  },
  getUnsignedPdf(id) {
    return http.request({
      method: 'get',
      url: `/signature-requests/${id}/unsigned-pdf`,
      responseType: 'blob',
    });
  },
};

export default signDocuments;
